module.exports = fox._r("images/promo/mob-login-icon.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/mob-login-icon.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/mob-login-icon.png
// module id = 180
// module chunks = 2